module.exports = __webpack_public_path__ + "1af5add3885b977fedcccec6c87e6709.jpg";